export default "__VITE_ASSET__b718d984__"